<script setup>
import { useProjectStore } from '@/store/project'
import { useBuildingStore } from '@/store/building'
import { useUnitStore } from '@/store/unit'
import { useSortStore } from '@/store/sort'
import { useFilterStore } from '@/store/filter'
import { usePlayerStore } from '@/store/players'

import UnitCard from '@/components/cards/UnitCard.vue'

const emits = defineEmits(['selectUnit'])

const playerStore = usePlayerStore()

const projectStore = useProjectStore()
const buildingStore = useBuildingStore()
const unitStore = useUnitStore()
const filtersStore = useFilterStore()

const { getUnitStatus } = projectStore

const project = projectStore.projectWithFieldsAndStatuses
const buildings = buildingStore.buildings
const { unitThumbnailByUnitId } = unitStore

const sortStore = useSortStore()

const units = computed(() => {
    return sortStore.sortUnits(filtersStore.filteredUnits)
})

const currentUnit = computed(() => {
    return playerStore.apartmentChooser.currentUnit
})

const unitRoute = (unitId) => {
    const unit = units.value.find((u) => u.unitId === unitId)
    if (unit) {
        const building = buildings.find((b) => b.id === unit.buildingId)
        if (building) {
            return `/${project.slug}/${building.slug}/${unitId}`
        }
    }

    return undefined
}

const selectUnit = (unit) => {
    emits('selectUnit', unit)
}

const selectUnitAndGoToUnitPage = (unit) => {
    selectUnit(unit)
    const route = unitRoute(unit.unitId)
    if (route) {
        navigateWithHash(route)
    }
}
</script>
<template>
    <v-col
        v-for="(unit, index) in units"
        :key="index"
        cols="6"
        sm="4"
        md="3"
        lg="3"
        xl="3"
        class="unit-grid-col d-flex flex-row align-stretch"
    >
        <UnitCard
            :project="project"
            :unit="unit"
            :unitThumbnail="unitThumbnailByUnitId(unit.unitId)"
            :unitStatus="getUnitStatus(unit)"
            :minimumWidth="`100%`"
            @click="selectUnitAndGoToUnitPage(unit)"
            class="unit-card"
            :class="{ 'active-card': currentUnit && unit.unitId === currentUnit.unitId }"
            link
        >
        </UnitCard>
    </v-col>
</template>
<style scoped>
.unit-card {
    border: 1.5px solid #cccccc;
}
.active-card {
    border-color: #0da54e;
}

@media screen and (max-width: 960px) {
    .unit-grid-col {
        padding: 5px;
    }
}
</style>
